module.exports = __webpack_public_path__ + "img/02.7b5c2fba.jpg";